import { useEffect, useMemo, useState } from 'react';

import OpenCloseMenuButton from './OpenCloseMenuButton';

function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : true
  );

  useEffect(() => {
    const media = window.matchMedia('(min-width: 1024px)');
    const handler = (event) => setIsDesktop(event.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}

export default function ShellMenuToggle({
  isSidebarExpanded = false,
  isMobileOpen = false,
  onToggleSidebar,
  onToggleMobile,
  size = 'md',
  variant = 'default',
  className,
}) {
  const isDesktop = useIsDesktop();

  const open = useMemo(
    () => (isDesktop ? isSidebarExpanded : isMobileOpen),
    [isDesktop, isSidebarExpanded, isMobileOpen]
  );

  const handleClick = () => {
    if (isDesktop) {
      onToggleSidebar?.();
      return;
    }

    onToggleMobile?.();
  };

  return (
    <OpenCloseMenuButton
      open={open}
      onClick={handleClick}
      size={size}
      variant={variant}
      className={className}
    />
  );
}
